/**
 * Created by slava on 3/31/17.
 */

const NotificationView = cc.Scale9Sprite.extend({
    ctor: function (model, message, options) {
        const frame = bundles.notification.frames.notification_bg;

        this._super(frame, cleverapps.UI.getScale9Rect(frame, cleverapps.UI.Scale9Rect.TwoPixelXY));

        this.model = model;

        const styles = cleverapps.styles.NotificationView;

        this.setLocalZOrder(WindowComponent.WINDOWS_ZORDER + 12);

        const text = cleverapps.UI.generateOnlyText(message, cleverapps.styles.FONTS.NOTIFICATION_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        let maxWidth = Math.min(cleverapps.resolution.getSceneSize().width * 0.85, styles.maxWidth);
        let textHeight = styles.text.height;

        if (options.progress) {
            this.bar = this.createBar(options.progress);
            textHeight -= this.bar.height * this.bar.scale + styles.progress.margin;
        }

        let image;
        if (options.image) {
            image = options.image instanceof cc.Node ? options.image : new cc.Sprite(options.image);
            cleverapps.UI.fitToBox(image, styles.image);
            maxWidth -= image.width * image.scale + styles.image.margin;
        }

        text.setDimensions(maxWidth, 0);
        text.fitTo(undefined, textHeight);

        this.content = text;

        if (this.bar) {
            this.content = new cleverapps.Layout([text, this.bar], {
                margin: styles.progress.margin,
                direction: cleverapps.UI.VERTICAL
            });
        }

        if (image) {
            this.content = new cleverapps.Layout([image, this.content], {
                margin: styles.image.margin,
                direction: cleverapps.UI.HORIZONTAL
            });
        }

        this.addChild(this.content);

        this.onResize();
        this.setAlignment(this.getHidePosition());

        if (!options.noSound) {
            cleverapps.effects.fire("ui.notification.show");
        }

        this.onShowListener = function () {
            if (!this.isRunning()) {
                return;
            }

            if (options.progress && options.progress.newAmount) {
                this.updateProgress(options.progress.newAmount, options.progress.total, 0.5);
            } else {
                this.delayAndHide();
            }
        }.bind(this);

        this.model.onRemove = this.createListener(() => {
            this.removeFromParent();
        });
        this.model.onUpdateProgress = this.createListener(this.updateProgress.bind(this));

        if (options.debugInfo) {
            this.setLocalZOrder(10000);
            this.model.onRemove = function () {};

            this.alwaysOn = true;

            cleverapps.UI.onPressed(this, () => {
                cleverapps.focusManager.display({
                    stack: true,
                    focus: "ErrorWindow",
                    action: function (f) {
                        new ErrorWindow(options);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            });
        }
    },

    createBar: function (progress) {
        const styles = cleverapps.styles.NotificationView.progress;
        const bar = new ScaledProgressBar({
            type: ScaledProgressBar.Types[styles.type],
            barText: {
                font: cleverapps.styles.FONTS.NOTIFICATION_PROGRESS_FONT
            },
            height: styles.height,
            progressFrames: styles.progressFrames
        });
        bar.setLength(styles.width);
        bar.setGoal(progress.total);
        bar.setPercentage(progress.amount);
        bar.setAnchorPoint(0.5, 0.5);
        cleverapps.UI.fitToBox(bar, { height: styles.height });
        return bar;
    },

    onResize: function () {
        const styles = cleverapps.styles.NotificationView;
        this.setScale((connector.info.isMobile ? styles.mobileScale : styles.scale)[cleverapps.resolution.mode]);

        const maxContentWidth = cleverapps.resolution.getSceneSize().width * 0.85;
        const scale = Math.min(1, maxContentWidth / this.content.width);

        this.setContentSize(
            Math.max(styles.minWidth, this.content.width * scale + 2 * styles.padding.x),
            Math.max(styles.minHeight, 2 * (this.content.height * scale + styles.padding.y))
        );

        this.content.setScale(scale);
        this.content.setAlignment({ x: { align: "center" }, y: { align: "bottom", dy: styles.padding.y } });

        this.stopAllActions();
        this.delayAndHide();
    },

    getHidePosition: function () {
        const safePadding = cleverapps.resolution.getSafePadding();
        return { x: { align: "center" }, y: { align: "top", dy: this.height * this.scaleY + safePadding.top } };
    },

    getShownPosition: function () {
        const styles = cleverapps.styles.NotificationView;
        return { x: { align: "center" }, y: { align: "top", dy: -styles.offsetY + this.height * this.scaleY / 2 } };
    },

    show: function () {
        if (this.shown || !this.isRunning()) {
            return;
        }
        this.shown = true;

        const shownPosition = this.getShownPosition();
        this.runAction(new cc.Sequence(
            new cc.MoveTo(0.2, this.positionFromAlignment(shownPosition)),
            new cc.CallFunc(() => {
                this.onShowListener();
            })
        )).setFinalize(() => {
            this.setAlignment(shownPosition);
        });
    },

    hide: function () {
        if (!this.shown || !this.isRunning()) {
            return;
        }
        this.shown = false;

        const hiddenPosition = this.getHidePosition();
        this.runAction(new cc.Sequence(
            new cc.MoveTo(0.5, this.positionFromAlignment(hiddenPosition)),
            new cc.CallFunc(() => {
                this.model.reset();
                this.model.processQueue();
            })
        )).setFinalize(() => {
            this.setAlignment(hiddenPosition);
        });
    },

    delayAndHide: function () {
        if (!this.isRunning()) {
            return;
        }

        this.delayAndHideAction = this.runAction(new cc.Sequence(
            new cc.DelayTime(3),
            new cc.CallFunc(this.hide.bind(this))
        ));
    },

    updateProgress: function (progress, total, delay) {
        if (!this.bar || !this.shown) {
            return;
        }

        this.stopAction(this.delayAndHideAction);
        this.stopAction(this.updateProgressAction);

        if (!this.isRunning()) {
            return;
        }

        delay = delay || 0;
        this.updateProgressAction = this.runAction(new cc.Sequence(
            new cc.DelayTime(delay),
            new cc.CallFunc(() => {
                this.delayAndHide();
                this.bar.setGoal(total);
                this.bar.setPercentage(progress, {
                    animated: true
                });

                if (progress >= total) {
                    this.bar.updateBarText(Messages.get("done"));
                    cleverapps.effects.fire("ui.notification.task.done");

                    if (bundles.notification.jsons.bar_flash_json) {
                        const animation = new cleverapps.Spine(bundles.notification.jsons.bar_flash_json); 
                        this.bar.addChild(animation);
                        animation.setAlignment(cleverapps.styles.NotificationView.progress.animation);
                        animation.setAnimation(0, "animation", false);
                        animation.setCompleteListenerRemove();
                    }
                }
            })
        )).setFinalize(() => {
            this.bar.setGoal(total);
            this.bar.setPercentage(progress);
            if (progress >= total) {
                this.bar.updateBarText(Messages.get("done"));
            }
        });
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    NOTIFICATION_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.NotificationView = {
    offsetY: 10,
    scale: [1, 1, 1],
    mobileScale: [0.5, 1, 1],

    text: {
        height: 100
    },

    image: {
        margin: 20,
        width: 200,
        height: 100,
        maxScale: 1.5
    },

    minWidth: 300,
    minHeight: 200,
    maxWidth: 750,

    padding: {
        x: 30,
        y: 40
    },

    progress: {
        margin: 10,
        width: 350,
        height: 30,
        type: "green",
        animation: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -2 }
        }
    }
};

NotificationView.ZORDER = WindowComponent.WINDOWS_ZORDER + 2;

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    NOTIFICATION_PROGRESS_FONT: {
        name: "default",
        size: 26
    }
});
